import { render, staticRenderFns } from "./ExternalStorage.vue?vue&type=template&id=1173b48f&scoped=true&"
import script from "./ExternalStorage.vue?vue&type=script&lang=ts&"
export * from "./ExternalStorage.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalStorage.vue?vue&type=style&index=0&id=1173b48f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1173b48f",
  null
  
)

export default component.exports